<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="'Incident Type Builder :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/incidents`">
                            <i class="fa fa-stethoscope"></i> Incidents
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/incidents/settings#incident_types`">Settings - Incident Types</router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <template v-if="incident_type.IncidentTypeId">{{ incident_type.TypeName }}</template>
                        <template v-else>New Incident Type</template>
                    </li>
                </ol>
            </h4>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4">
                <b-nav-item :active="curTab === 'general'" @click="curTab = 'general'">
                    General Settings
                </b-nav-item>
                <b-nav-item :active="curTab === 'custom'" @click="curTab = 'custom'" v-if="IncidentTypeId">
                    Custom Sections &amp; Fields
                </b-nav-item>
            </ul>

            <div v-if="curTab === 'general'">
                <div class="mt-2 mb-4">
                    <button type="button" class="btn btn-sm btn-success" @click="saveIncidentType()" :disabled="saving">
                        <template v-if="!saving">
                            <i class="fa fa-floppy-o"></i> Save Incident Type
                        </template>
                        <template v-else>
                            <i class="fa fa-spin fa-spinner"></i> Saving
                        </template>
                    </button>
                    <template v-if="false">
                        <router-link :to="`/admin/incident-types/publish/${incident_type.IncidentTypeId}`" class="btn btn-sm btn-primary" v-if="incident_type.IncidentTypeId && incident_type.published_at == null">
                            <i class="fa fa-flag-checkered"></i> Publish
                        </router-link>
                    </template>
                </div>
                <div class="row">
                    <div class="col-xl-9 col-lg-12">
                        <div class="card mb-3">
                            <div class="card-header">Basic Fields</div>
                            <div class="card-body">

                                <div class="form-group row">
                                    <label :class="{'col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right': true, 'text-danger': errors.TypeName }">Incident Type Name:</label>
                                    <div class="col-sm-6">
                                        <input type="text" name="TypeName" v-model="incident_type.TypeName" placeholder="Enter Incident Type Name" :class="{'form-control': true, 'is-invalid': errors.TypeName}" />
                                        <span v-if="errors.TypeName" class="text-danger">
                                            <span v-for="error in errors.TypeName">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div v-bind:class="{ 'form-group': true}" class="row">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Is Active:</label>
                                    <div class="col-sm-8 pt-2">
                                        <b-form-checkbox v-model="incident_type.IsActive" :value="1" :unchecked-value="0" plain />
                                    </div>
                                </div>
                                <div class="form-group row" v-if="incident_type.IncidentTypeId && incident_type.published_at">
                                    <label class="col-lg-2 col-md-3 col-sm-4 col-form-label text-sm-right">Published At:</label>
                                    <div class="col-sm-8 pt-2">
                                        <div class="mb-2"><strong>{{ incident_type.published_at | moment("timezone", userTimezone, "MM/DD/YYYY hh:mm A") }}</strong></div>
                                        <div class="alert alert-warning">This Incident Type has been published. You can still add sections, fields, and new options, but you cannot edit existing fields.</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Jobsite Settings <span class="text-muted small">Allows you to set required vs. optional jobsite fields</span></div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Jobsite:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">
                                        <b-form-checkbox v-model="incident_type.inci_require_jobsite" :value="1" :unchecked-value="0" plain />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Personnel Settings <span class="text-muted small">Allows you to set required vs. optional personnel fields</span></div>
                            <div class="card-body">
                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.inci_require_foreman }" class="row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Incident Foreman:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_foreman" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_foreman" class="text-danger">
                                            <span v-for="error in errors.inci_require_foreman">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.inci_require_pm }" class="row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Project Manager:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_pm" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_pm" class="text-danger">
                                            <span v-for="error in errors.inci_require_pm">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.inci_require_superintendent }" class="row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Superintendent:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_superintendent" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_superintendent" class="text-danger">
                                            <span v-for="error in errors.inci_require_superintendent">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.inci_require_supervisor }" class="row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Supervisor:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_supervisor" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_supervisor" class="text-danger">
                                            <span v-for="error in errors.inci_require_supervisor">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Crew Settings <span class="text-muted small">Allows you to set required vs. optional crew fields</span></div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Crew Size:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_crew_size" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_crew_size" class="text-danger">
                                            <span v-for="error in errors.inci_require_crew_size">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Crew Members:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_crew_members" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_crew_members" class="text-danger">
                                            <span v-for="error in errors.inci_require_crew_members">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Disciplinary Settings <span class="text-muted small">Allows you to set required vs. optional jobsite fields</span></div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Enable Disciplinary Section:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">
                                        <b-form-checkbox v-model="incident_type.inci_require_disc_actions" :value="1" :unchecked-value="0" plain />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Incident Details Settings <span class="text-muted small">Allows you to set required vs. optional jobsite fields</span></div>
                            <div class="card-body">
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">
                                        Require Major Body Part:
                                    </label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">
                                        <b-form-checkbox v-model="incident_type.inci_require_major_body_part" :value="1" :unchecked-value="0" plain />

                                        <span v-if="errors.inci_require_major_body_part" class="text-danger">
                                            <span v-for="error in errors.inci_require_major_body_part">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">
                                        Require Specific Body Part:
                                    </label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">
                                        <b-form-checkbox v-model="incident_type.inci_require_specific_body_part" :value="1" :unchecked-value="0" plain />

                                        <span v-if="errors.inci_require_specific_body_part" class="text-danger">
                                            <span v-for="error in errors.inci_require_specific_body_part">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">
                                        Require Nature of Injury:
                                    </label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">
                                        <b-form-checkbox v-model="incident_type.inci_require_injury_nature" :value="1" :unchecked-value="0" plain />

                                        <span v-if="errors.inci_require_injury_nature" class="text-danger">
                                            <span v-for="error in errors.inci_require_injury_nature">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">Other Field Settings <span class="text-muted small">Allows you to control which fields are required vs. optional</span></div>
                            <div class="card-body">


                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Type of Work Performed:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_type_of_work" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_type_of_work" class="text-danger">
                                            <span v-for="error in errors.inci_require_type_of_work">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Root Cause Analysis:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_root_cause" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_root_cause" class="text-danger">
                                            <span v-for="error in errors.inci_require_root_cause">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div class="form-group row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Require Corrective Action(s):</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_require_correct_action" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_require_correct_action" class="text-danger">
                                            <span v-for="error in errors.inci_require_correct_action">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>

                                <div v-bind:class="{ 'form-group': true, 'has-error': errors.inci_ptp_reminder }" class="row">
                                    <label class="col-lg-4 col-md-5 col-sm-6 col-12 col-form-label text-sm-right">Show Reminder to Upload PTP if PTP was completed:</label>
                                    <div class="col-lg-8 col-md-7 col-sm-6 col-12 pt-sm-2">

                                        <b-form-checkbox v-model="incident_type.inci_ptp_reminder" :value="1" :unchecked-value="0" plain />


                                        <span v-if="errors.inci_ptp_reminder" class="text-danger">
                                            <span v-for="error in errors.inci_ptp_reminder">{{ error }}</span>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <button type="button" class="btn btn-sm btn-success" @click="saveIncidentType()" :disabled="saving">
                            <template v-if="!saving">
                                <i class="fa fa-floppy-o"></i> Save Incident Type
                            </template>
                            <template v-else>
                                <i class="fa fa-spin fa-spinner"></i> Saving
                            </template>
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="curTab === 'custom'">
                <div class="mt-2 mb-4">
                    <button type="button" class="btn btn-sm btn-success" @click="saveIncidentType()" :disabled="saving">
                        <template v-if="!saving">
                            <i class="fa fa-floppy-o"></i> Save Incident Type
                        </template>
                        <template v-else>
                            <i class="fa fa-spin fa-spinner"></i> Saving
                        </template>
                    </button>

                    <button type="button" class="btn btn-sm btn-info" @click="show_set = true">
                        Edit Custom Field Set
                    </button>

                    <template v-if="incident_type.cf_set_id !== null || incident_type.cf_set_id === 0">
                        <button type="button" class="btn btn-sm btn-secondary" @click="addSection">
                            <i class="fa fa-plus-circle"></i> Add Section
                        </button>
                        <button type="button" class="btn btn-sm btn-warning" @click="show_preview = true">
                            <i class="fa fa-eye"></i> Preview Custom Fields
                        </button>
                    </template>
                </div>

                <div class="row">
                    <div class="col-lg-9 col-12">
                        <div class="card mb-3" v-if="show_set">
                            <div class="card-header">
                                <div class="row">
                                    <label class="mr-3 text-muted">Select Custom Field Set:</label>
                                </div>
                            </div>
                            <div class="card-body form-inline">
                                <div class="form-group mr-4">
                                    <b-form-select v-model="incident_type.cf_set_id" :options="cf_sets" style="width: 300px;" />
                                </div>
                                <div class="form-group" v-if="incident_type.cf_set_id === 0">
                                    <label>Set Name:&nbsp;</label>
                                    <b-form-input :disabled="incident_type.cf_set_id === null" v-model="incident_type.set_name" style="width: 300px;" placeholder="Enter Name for Custom Field Set" />
                                    <div class="alert alert-danger"  v-if="errors['set_name']">
                                        <strong>Validation Errors:</strong>
                                        <ul>
                                            <li v-for="err in errors['set_name']">{{ err }}</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-for="(section, key) in sections">
                            <div class="card mb-3">
                                <div class="card-header">
                                    <div class="row">
                                        <div class="col-md-6 col-12 form-inline">
                                            <div class="form-group">
                                                <label class="mr-3 text-muted">Section Name:</label> <b-form-input v-model="section.section_name" placeholder="Enter Section Name" size="sm" style="min-width: 200px;" />
                                            </div>
                                            <div class="form-group mt-1">
                                                <label class="mr-3 text-muted">Append to Base Section:</label> <b-form-select v-model="section.base_section" :options="baseSectionOptions" size="sm" style="min-width: 200px;" />
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-12">
                                            <div class="float-right">
                                                <button class="btn btn-sm btn-light" @click="section.show_body = !section.show_body" :title="(section.show_body ? 'Hide' : 'Show') + ' Section Fields'">
                                                    <i :class="'fa fa-caret-' + (section.show_body ? 'up' : 'down')"></i>
                                                </button>
                                                <button class="btn btn-sm btn-light" @click="addField(section, key)" title="Add Field" v-if="!incident_type.published_at || createdAfterPublished(section)">
                                                    <i class="fa fa-plus-circle text-success"></i>
                                                </button>
                                                <button class="btn btn-sm btn-light" @click="sections.splice(key, 1)" title="Delete Section" v-if="!incident_type.published_at || createdAfterPublished(section)">
                                                    <i class="fa fa-trash text-danger"></i>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div :class="{'card-body bg-light': true, 'd-none': !section.show_body}">

                                    <div class="alert alert-danger"  v-if="errors['sections.'+key] && section.fields.length == 0">
                                        <strong>Validation Errors:</strong>
                                        <ul>
                                            <li v-for="err in errors['sections.'+key]">{{ err }}</li>
                                        </ul>
                                    </div>

                                    <div v-if="section.fields.length == 0" style="border: 1px dashed #ccc; padding: 10px 20px; text-align: center; height: 50px; line-height: 50px; background: #fff;">
                                        <p style="display: inline-block; vertical-align: middle; line-height: normal; color: #ccc;">
                                            Click the
                                            <button class="btn btn-sm btn-link" @click="addField(section, key)" title="Add Field" v-if="!incident_type.published_at || createdAfterPublished(section)">
                                                <i class="fa fa-plus-circle text-success"></i>
                                            </button>
                                            in the Section Heading to start adding fields
                                        </p>
                                    </div>
                                    <div>
                                        <div class="card mb-2" v-for="(field, elemKey) in section.fields" :key="field.id">
                                            <div :class="{'card-header': true, 'text-danger': errors[field.id]}">
                                                <div class="row">
                                                    <div class="col-md-6 col-12 form-inline">
                                                        <span class="mr-2">{{ field.label || ''}}: <span class="text-muted" title="This is the field's type.">{{ field.type }}</span></span>
                                                    </div>
                                                    <div class="col-md-6 col-12">
                                                        <div class="float-right">
                                                            <input type="text" :value="field.order" class="form-control form-control-sm d-inline-block" placeholder="Field Order" style="width: 65px" title="Field Order" @input="setFieldOrder(field.id, $event)" />
                                                            <button class="btn btn-sm btn-light" @click="toggleField(field.id)" :title="(field.show_body ? 'Hide' : 'Show') + ' Field Options'">
                                                                 <i :class="'fa fa-caret-' + (field.show_body !== true ? 'down' : 'up')"></i>
                                                            </button>
                                                            <button class="btn btn-sm btn-light" @click="section.fields.splice(elemKey, 1)" title="Delete Field" v-if="!incident_type.published_at || createdAfterPublished(field)">
                                                                <i class="fa fa-trash text-danger"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div :class="{'card-body': true, 'd-none': (!field.show_body || field.show_body == false)}"> -->
                                            <div :class="{'card-body': true, 'd-none': (field.show_body == false)}">

                                                <div class="form-group row mb-2" v-if="errors[field.id]">
                                                    <div class="col-sm-10 offset-sm-1">
                                                        <div class="alert alert-danger">
                                                            <strong>Validation Errors:</strong>
                                                            <ul>
                                                                <li v-for="err in errors[field.id]">{{ err }}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Only Render This Field If:</label>
                                                    <div class="col-sm-8 pt-2">
                                                        <b-form-select v-model="field.parent_field_id" :options="conditionalFieldOptions(field.id)" size="sm">
                                                            <template v-slot:first>
                                                                <option :value="null">-- Select A Parent Field. Leave Blank to Always Show this Field --</option>
                                                            </template>
                                                        </b-form-select>
                                                        <b-form-select v-if="field.parent_field_id" v-model="field.parent_field_value" :options="conditionalFieldValues(field.parent_field_id)" size="sm" class="mt-2">
                                                            <template v-slot:first>
                                                                <option :value="null">-- Select A Value --</option>
                                                            </template>
                                                        </b-form-select>
                                                    </div>
                                                </div>

                                                <template v-if="field.type != 'Paragraph' && field.type != 'Heading'">
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Required:</label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-checkbox v-model="field.is_required" :value="1" :unchecked-value="0" plain></b-form-checkbox>
                                                        </div>
                                                    </div>
                                                </template>

                                                <div class="form-group row" v-if="field.type != 'Paragraph'">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Label:</label>
                                                    <div class="col-sm-8">
                                                        <b-form-input v-model="field.label" placeholder="Enter a Field Label" size="sm" class="mr-2" />
                                                    </div>
                                                </div>

                                                <div class="form-group row">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Help Text:</label>
                                                    <div class="col-sm-8">
                                                        <b-form-input v-model="field.help_text" placeholder="Enter Some Help Text for the Field" size="sm" />
                                                    </div>
                                                </div>

                                                <div class="form-group row" v-if="('placeholder' in field)">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Placeholder:</label>
                                                    <div class="col-sm-8">
                                                        <b-form-input v-model="field.placeholder" placeholder="Enter a Placeholder Label" size="sm" />
                                                    </div>
                                                </div>

                                                <template v-if="field.type == 'Dropdown'">
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right"></label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                                                            Options:<br>
                                                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <div v-for="(option, key) in field.options" class="form-inline mb-2">
                                                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />

                                                                <template v-if="!incident_type.published_at || createdAfterPublished(field)">
                                                                    <a href="javascript:void(0)" class="text-danger ml-2" v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></a>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-if="field.type == 'Radio' || field.type == 'Checkbox'">
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Vertical Display:</label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-checkbox v-model="field.display_vertical" :value="true" :unchecked-value="false" plain>Display the options vertically. Default is inline.</b-form-checkbox>
                                                        </div>
                                                    </div>
                                                    <!-- <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Enable "Other":</label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-checkbox v-model="field.enable_other" :value="true" :unchecked-value="false" plain>Let users to enter an unlisted option</b-form-checkbox>
                                                        </div>
                                                    </div> -->
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">
                                                            Options:<br>
                                                            <a href="javascript:void(0)" @click="$set(field.options, `field-${new Date().getTime()}`)">Add Option <i class="fa fa-plus-circle"></i></a>
                                                        </label>
                                                        <div class="col-sm-8">
                                                            <div v-for="(option, key) in field.options" class="form-inline">
                                                                <!-- <span class="mr-2">Option {{ key + 1 }}:</span> -->
                                                                <b-form-input v-model="field.options[key]" placeholder="Enter Option" size="sm" />
                                                                <button type="button" class="btn btn-link text-danger"  v-on:click="deleteOption(field.id, key)"><i class="fa fa-trash"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                                <template v-if="field.type == 'Radio' || field.type == 'Checkbox' || field.type == 'Dropdown'">
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Require Core Field:</label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-select v-model="field.core_field_key" :options="coreFieldOptions" size="sm">
                                                                <template v-slot:first>
                                                                    <option :value="null">-- Select Core Field. Leave Blank to Ignore this Feature --</option>
                                                                </template>
                                                            </b-form-select>
                                                        </div>
                                                    </div>
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">IF this field =</label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-select v-model="field.core_field_value" :options="conditionalFieldValues(field.id)" size="sm" class="mt-2">
                                                                <template v-slot:first>
                                                                    <option :value="null">-- Select A Value --</option>
                                                                </template>
                                                            </b-form-select>
                                                        </div>
                                                    </div>
                                                </template>

                                                <div class="form-group row" v-if="field.type == 'File'">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Allowed File Types:</label>
                                                    <div class="col-sm-8">
                                                        <div class="text-info mb-1">-- Leave Unchecked to Allow All File Types --</div>
                                                        <b-form-checkbox-group v-model="field.file_types" stacked plain :options="fileTypeOptions"></b-form-checkbox-group>
                                                    </div>
                                                </div>

                                                <div class="form-group row" v-if="field.type == 'Textarea'">
                                                    <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Rich Text:</label>
                                                    <div class="col-sm-8">
                                                        <b-form-checkbox v-model="field.enable_rich_text" :value="true" :unchecked-value="false" plain>
                                                            Enable Rich Text
                                                        </b-form-checkbox>
                                                        <p>This will activate the rich text editor that allows users to bold, highlight, list, and edit text.</p>
                                                    </div>
                                                </div>

                                                <template v-if="field.type == 'Number'">
                                                    <div class="form-group row"">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Min:</label>
                                                        <div class="col-sm-8">
                                                            <b-form-input v-model="field.min" placeholder="Enter Min Value" size="sm"></b-form-input>
                                                        </div>
                                                    </div>
                                                    <div class="form-group row"">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Max:</label>
                                                        <div class="col-sm-8">
                                                            <b-form-input v-model="field.max" placeholder="Enter Max Value" size="sm"></b-form-input>
                                                        </div>
                                                    </div>
                                                    <div class="form-group row"">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Step:</label>
                                                        <div class="col-sm-8">
                                                            <b-form-input v-model="field.step" placeholder="Enter Step Value" size="sm"></b-form-input>
                                                        </div>
                                                    </div>
                                                </template>

                                                <!-- <template v-if="field.type == 'Employee' || field.type == 'Equipment' || field.type == 'Jobsite' || field.type == 'User'">
                                                    <div class="form-group row">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right"></label>
                                                        <div class="col-sm-8 pt-2">
                                                            <b-form-checkbox v-model="field.allow_multiple" :value="true" :unchecked-value="false" plain>Allow Multiple Selections</b-form-checkbox>
                                                        </div>
                                                    </div>
                                                </template> -->

                                                <template v-if="field.type == 'Paragraph'">
                                                    <div class="form-group row"">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Block Text:</label>
                                                        <div class="col-sm-8">
                                                            <b-form-textarea v-model="field.text" placeholder="Enter Block Text" rows="5"></b-form-textarea>
                                                        </div>
                                                    </div>
                                                    <div class="form-group row"">
                                                        <label class="col-lg-3 col-sm-4 col-form-label text-sm-right">Background Color:</label>
                                                        <div class="col-sm-8">
                                                            <b-form-radio-group plain v-model="field.color">
                                                                <b-form-radio :value="null">
                                                                    <i class="fa fa-square-o"></i> -- None --
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="primary">
                                                                    <i class="fa fa-square text-primary"></i> Primary
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="secondary">
                                                                    <i class="fa fa-square text-secondary"></i> Secondary
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="info">
                                                                    <i class="fa fa-square text-info"></i> Info
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="warning">
                                                                    <i class="fa fa-square text-warning"></i> Warning
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="success">
                                                                    <i class="fa fa-square text-success"></i> Success
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="danger">
                                                                    <i class="fa fa-square text-danger"></i> Danger
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="light">
                                                                    <i class="fa fa-square text-light"></i> Light
                                                                </b-form-radio><br/>
                                                                <b-form-radio value="dark">
                                                                    <i class="fa fa-square text-dark"></i> Dark
                                                                </b-form-radio><br/>
                                                            </b-form-radio-group>
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>

                    <div class="col-lg-3 col-12">
                        <div class="list-group" v-if="debug">
                          <pre>{{listString}}</pre>
                        </div>
                        <div class="card mb-3">
                            <div class="card-header">
                                <strong>What Are Custom Field Sets?</strong>
                            </div>
                            <div class="card-body">
                                <p>
                                Custom field sets are groups of custom fields and sections that are used for an incident type. These sets can also be shared with other incident types.
                                </p>
                                <p>
                                Incident types that share the same custom field set allows users to toggle an incident between these shared types. For example, given incident type "FA - Onsite" and "FA - Medical" that share the same custom field set, an incident could change from "FA - Onsite" to "FA - Medical" or visa versa.
                                </p>
                                <p v-if="incident_type.cf_set_id">
                                    This set is currently used on the following types:
                                    <ul>
                                        <li><strong>
                                            {{incident_type.TypeName}} (Current Type)
                                        </strong></li>
                                        <li v-for="type in cf_set_type_list">
                                            {{type}}
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>

                        <div class="card mb-3">
                            <div class="card-header">
                                <strong>Section/Field Summary</strong>
                            </div>
                            <div class="card-body">
                                <ul>
                                    <li v-for="section in sections">
                                        {{ section.section_name }}
                                        <template v-if="section.section_name && section.base_section"> - </template>
                                        <template v-if="section.base_section">{{ getSectionName(section.base_section) }} Section</template>
                                        <ul>
                                            <li v-for="field in section.fields">{{ field.label }}</li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <!-- Modal Component -->
            <b-modal v-model="show_preview" title="Form Preview" size="lg" no-fade :no-close-on-backdrop="true" ok-only ok-variant="secondary" ok-title="Close">

                <incident-sections-builder :sections="previewSections"></incident-sections-builder>

            </b-modal>

            <b-modal v-model="show_fields" title="Add Field Preview" size="lg" no-fade :no-close-on-backdrop="true" ok-variant="success" ok-title="Add Field" @ok="fieldAdded">

                <b-form-radio-group plain v-model="new_field">
                    <strong>Standard Fields</strong>
                    <ul class="list-group mb-4 bg-white">
                        <li class="list-group-item" v-for="field in fields" :key="field.id">
                            <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                        </li>
                    </ul>

                    <strong>Formatted Fields</strong>
                    <ul class="list-group mb-4 bg-white">
                        <li class="list-group-item" v-for="field in formattedFields" :key="field.id">
                          <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                        </li>
                    </ul>

                    <strong>Lookup Fields - These are pulled from your lists of data.</strong>
                    <ul class="list-group mb-4 bg-white">
                        <li class="list-group-item" v-for="field in lookUpFields" :key="field.id">
                          <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                        </li>
                    </ul>

                    <strong>Helpers - Insert Help Messages or Reminders for Users filling out your form.</strong>
                    <ul class="list-group bg-white">
                        <li class="list-group-item" v-for="field in helperFields" :key="field.id">
                          <b-form-radio :value="field.id">{{ field.type }}</b-form-radio>
                        </li>
                    </ul>
                </b-form-radio-group>

            </b-modal>
        </div>
    </div>
</template>

<script>
    import moment from 'moment-timezone';

    export default {

        data: function() {
            return {
                userTimezone: this.$store.state.user.timezone,
                IncidentTypeId: this.$route.params.id,
                loading: true,
                saving: false,
                isDragging: false,
                show_preview: false,
                show_set: false,
                show_fields: false,
                new_field: null,
                editing_section: null,
                // debug: this.$root.$data.debug,
                debug: false,
                curTab: 'general',
                errors: {},
                injuryTypes: [],
                hazards: [],
                behaviors: [],
                conditions: [],
                incident_type: {
                    TypeName: '',
                    IsActive: 1,
                    inci_require_jobsite: 1,
                    inci_require_foreman: 1,
                    inci_require_pm: 1,
                    inci_require_superintendent: 1,
                    inci_require_supervisor: 0,
                    inci_ptp_reminder: 1,
                    inci_require_crew_size: 1,
                    inci_require_crew_members: 1,
                    inci_require_disc_actions: 0,
                    inci_require_injury_nature: 0,
                    inci_require_major_body_part: 0,
                    inci_require_specific_body_part: 0,
                    inci_require_type_of_work: 0,
                    inci_require_root_cause: 0,
                    inci_require_correct_action: 0,
                },
                sections: [],
                originalSections: [],
                fields: [
                    {id: 1, type: 'Text', placeholder: '', parent_field_id: null},
                    {id: 2, type: 'Dropdown', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 3, type: 'Radio', parent_field_id: null, options: {}, display_vertical: false, enable_other: false},
                    {id: 4, type: 'Checkbox', parent_field_id: null, options: {}, display_vertical: false, enable_other: false},
                    {id: 5, type: 'Textarea', parent_field_id: null, placeholder: '', enable_rich_text: false},
                    //{id: 18, type: 'File', parent_field_id: null, placeholder: ''},
                ],
                formattedFields: [
                    {id: 6, type: 'Date', parent_field_id: null, placeholder: '', format: 'MM/DD/YYYY'},
                    {id: 7, type: 'Time', parent_field_id: null, placeholder: ''},
                    {id: 8, type: 'Email', parent_field_id: null, placeholder: ''},
                    {id: 9, type: 'Phone', parent_field_id: null, placeholder: '', format: 'XXX-XXX-XXXX'},
                    {id: 10, type: 'Number', parent_field_id: null, placeholder: '', min: null, max: null, step: null},
                ],
                helperFields: [
                    {id: 12, type: 'Heading', parent_field_id: null, tag: 'h1'},
                    {id: 13, type: 'Paragraph', parent_field_id: null, color: 'info', text: ''},
                ],
                lookUpFields: [
                    {id: 14, type: 'Employee', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 15, type: 'Equipment', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 16, type: 'Jobsite', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                    {id: 17, type: 'User', placeholder: '', parent_field_id: null, options: {}, allow_multiple: false},
                ],
                cf_sets: [],
                cf_set_type_list: [],

                core_fields: {
                    foreman_id: 'Foreman',
                    leadman_id: 'Leadman',
                    superintendent_id: 'Superintendent',
                    project_manager_id: 'Project Manager',
                    equipment_id: 'Equipment',
                    hazards: 'Root Cause Analysis - Hazards',
                    behaviors: 'Root Cause Analysis - Behavoirs',
                    conditions: 'Root Cause Analysis - Conditions',
                    InjuryObjectOrSubstance: 'Object or Substance Directly Harmed Employee',
                    MedicalProfessional: 'Medical Professional',
                    IsReturnToWork: 'Did Employee Return to Work',
                    ReturnToWorkDate: 'Date Returned to Work',
                    FacilityTypeId: 'Place of Treatment',
                },

                file_types: {
                    'csv': 'CSV',
                    'doc': 'DOC',
                    'docx': 'DOCX',
                    'gif': 'GIF',
                    'pdf': 'PDF',
                    'png': 'PNG',
                    'jpeg': 'JPEG',
                    'jpg': 'JPG',
                    'tiff': 'TIFF',
                    'xls': 'XLS',
                    'xlsx': 'XLSX',
                },
            }
        },

        computed: {

            dragOptions() {
                return {
                    animation: 0,
                    group: "description",
                    disabled: !this.editable,
                    ghostClass: "ghost"
                };
            },

            listString() {
              return JSON.stringify(this.sections, null, 2);
            },

            conditionalFieldOptions_OLD(){
                //Build based on the list of sections and their fields
                var parentFields = [];

                //Loop through the sections
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the type
                        if(this.sections[i].fields[j].type != 'Dropdown' && this.sections[i].fields[j].type != 'Radio' && this.sections[i].fields[j].type != 'Checkbox')
                        {
                            continue;
                        }

                        //Add the Option
                        parentFields.push({value: this.sections[i].fields[j].id, text: (this.sections[i].fields[j].label ? this.sections[i].fields[j].label : this.sections[i].fields[j].id)});
                    }
                }

                //SEnd it
                return parentFields;
            },

            publishedSections(){
                //Check if the incident type is published
                if(this.incident_type.published_at)
                {
                    return this.originalSections;
                }

                //Send it
                return [];
            },

            baseSections(){
                //Check if the incident has the Employee Disciplinary Actions turned on
                if(this.incident_type.inci_require_disc_actions == 1)
                {
                    return {
                        additional: 'Additional',
                        actions: 'Corrective Actions',
                        crew_members: 'Crew Members',
                        description: 'Detailed Description of Incident',
                        employee: 'Employee Information',
                        disc_action: 'Employee Disciplinary Actions',
                        equipment: 'Equipment',
                        files: 'Files & Photos',
                        injury: 'Injury/Medical',
                        participants: 'Investigation Participants',
                        incident: 'Incident Details',
                        jobsite: 'Jobsite Information',
                        root_cause: 'Root Cause Analysis',
                        type_of_work: 'Type of Work Being Performed at Time of Incident',
                    };
                }
                return {
                    additional: 'Additional',
                    actions: 'Corrective Actions',
                    crew_members: 'Crew Members',
                    description: 'Detailed Description of Incident',
                    employee: 'Employee Information',
                    equipment: 'Equipment',
                    files: 'Files & Photos',
                    injury: 'Injury/Medical',
                    participants: 'Investigation Participants',
                    incident: 'Incident Details',
                    jobsite: 'Jobsite Information',
                    root_cause: 'Root Cause Analysis',
                    type_of_work: 'Type of Work Being Performed at Time of Incident',
                };
            },

            baseSectionOptions(){
                //Setup options
                var options = [
                    {value: null, text: '-- Select Base Section to Append To --'},
                ];

                //Setup
                const keys = Object.keys(this.baseSections);

                //Loop through and build lists
                for(var i = 0; i < keys.length; i++)
                {
                    //Push onto options
                    options.push({value: keys[i], text: this.baseSections[keys[i]]});
                }

                //Send it
                return options;
            },

            previewSections(){
                //Setup
                var sections = [];

                //Loop through and build lists
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.sections[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    sections.push(sec);
                }

                //Send it
                return sections;
            },

            coreFieldOptions(){
                //Setup
                var options = [];

                //Setup
                const keys = Object.keys(this.core_fields);

                //Loop through and build lists
                for(var i = 0; i < keys.length; i++)
                {
                    //Push onto options
                    options.push({value: keys[i], text: this.core_fields[keys[i]]});
                }

                //Send ti
                return options;
            },

            fileTypeOptions(){
                //Setup
                var options = [];

                //Setup
                const keys = Object.keys(this.file_types);

                //Loop through and build lists
                for(var i = 0; i < keys.length; i++)
                {
                    //Push onto options
                    options.push({value: keys[i], text: this.file_types[keys[i]]});
                }

                //Send ti
                return options;
            },
        },

        watch: {
            'incident_type.cf_set_id'(newValue, oldValue) {
                //Check for null or 0
                if(newValue === null)
                {
                    return;
                }
                else if(newValue === 0)
                {
                    this.getCfSetData(newValue);
                }

                //Get the Type
                this.getCfSetData(newValue);
            }
        },

        methods: {
            //Add a Section
            addSection(){
                //Push
                this.sections.push({
                    id: 'section-' + new Date().getTime(),
                    section_name: '',
                    fields: [],
                    show_body: true,
                    base_section: null,
                });
            },

            addField(section, key){
                //Setter
                this.show_fields = true;

                //Adding to section
                this.editing_section = key;
            },

            fieldAdded(bvEvt) {
                //Make sure the user selected a field
                if(!this.new_field)
                {
                    //Alert the user
                    this.$toastr.warning('Select a Field to Add');

                    //Keep the modal open
                    bvEvt.preventDefault();

                    //Stop here
                    return;
                }

                //Get the field by ID and send it
                var fieldDefinition = this.getFieldById(this.new_field);

                //Clone it
                this.sections[this.editing_section].fields.push(this.cloneField(fieldDefinition, this.sections[this.editing_section].fields.length));

                //Reset
                this.editing_section = null;
                this.new_field = null;
            },

            getFieldById(id){
                //Loop through all
                for(var i = 0; i < this.fields.length; i++)
                {
                    //Check the if
                    if(id == this.fields[i].id)
                    {
                        return this.fields[i];
                    }
                }

                //Loop through all
                for(var i = 0; i < this.formattedFields.length; i++)
                {
                    //Check the if
                    if(id == this.formattedFields[i].id)
                    {
                        return this.formattedFields[i];
                    }
                }
                //Loop through all
                for(var i = 0; i < this.lookUpFields.length; i++)
                {
                    //Check the if
                    if(id == this.lookUpFields[i].id)
                    {
                        return this.lookUpFields[i];
                    }
                }

                //Loop through all
                for(var i = 0; i < this.helperFields.length; i++)
                {
                    //Check the if
                    if(id == this.helperFields[i].id)
                    {
                        return this.helperFields[i];
                    }
                }
            },

            //Clones a Field to a New Element
            cloneField(field, numExistingFields){
                //Setup
                var newField = JSON.parse(JSON.stringify(field));

                //Modify the field
                newField.id = field.type.toLowerCase() + '-' + new Date().getTime();
                newField.show_body = true;
                newField.core_field_key = null;
                newField.core_field_value = null;
                newField.order = numExistingFields;

                //Send it
                return newField;
            },

            toggleField(fieldId){
                //Loop through all
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through all
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the if
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Replace it to force a redraw
                            var field = this.sections[i].fields[j];

                            //SEtter
                            field.show_body = field.show_body === true || field.show_body === undefined ? false : true;

                            //Set
                            this.sections[i].fields.splice(j, 1, field);

                            //Set it
                            return;
                        }
                    }
                }
            },

            deleteOption(fieldId, optionIndex){
                //Loop through all
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through all
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the if
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Replace it to force a redraw
                            var field = this.sections[i].fields[j];

                            //IF the fields core_field_value is the option, set it to null
                            if(field.core_field_value == optionIndex)
                            {
                                field.core_field_value = null;
                            }

                            //Remove the option
                            delete field.options[optionIndex];

                            //Set
                            this.sections[i].fields.splice(j, 1, field);

                            //Set it
                            return;
                        }
                    }
                }
            },

            getCfSetData(set_id) {
                //Get the data
                this.loading = true;

                if (!set_id)
                {
                    // Either a new set or no set, either way clear it all out
                    this.sections = [];
                    this.originalSections = [];
                    this.cf_set_type_list = [];
                    this.incident_type.set_name = null;
                }

                let before = (new Date()).getTime();
                let wait_time = 1000;

                if (set_id !== 0)
                {
                    let data = {};

                    if (this.IncidentTypeId)
                    {
                        data.incident_type_id = this.IncidentTypeId;
                    }

                    this.$http
                        .get(`admin/incident-types-sets${set_id ? `/${set_id}` : ''}`, data)
                        .then(response => {
                            //Set all the data
                            this.sections = response.data.custom_fields;
                            this.cf_set_type_list = response.data.cf_set_type_list;
                            this.originalSections = JSON.parse(JSON.stringify(this.sections));
                            this.incident_type.set_name = response.data.set_name;

                            //Set loading
                            let after = (new Date()).getTime();
                            setTimeout(() => {
                                this.loading = false;
                            }, (after - before > wait_time) ? 0 : wait_time - (after - before));
                        })
                        .catch(response => {

                        });
                }
                else
                {
                    this.incident_type.set_name = this.incident_type.TypeName;

                    let after = (new Date()).getTime();
                    setTimeout(() => {
                        this.loading = false;
                    }, (after - before > wait_time) ? 0 : wait_time - (after - before));
                }
            },

            getIncidentType() {
                //Check for the ID
                if(!this.IncidentTypeId)
                {
                    //Stop here
                    this.loading = false;

                    //Push 1 new section
                    //this.addSection();

                    //Stop here
                    return;
                }

                //Get the data
                this.$http
                    .get('admin/incident-types-edit' + (this.IncidentTypeId ? '/' + this.IncidentTypeId : ''))
                    .then(response => {
                        //Set all the data
                        this.incident_type = response.data.incidentType;
                        this.cf_sets = response.data.cf_sets;

                        //Get the CF Set Data
                        //this.getCfSetData(this.incident_type.cf_set_id);

                        //IF the set is null, show the set
                        if(this.incident_type.cf_set_id === null)
                        {
                            //Show the Hlper
                            this.show_set = true;

                            this.loading = false;
                        }
                    })
                    .catch(response => {

                    });
            },

            saveIncidentType(){
                //SHow loading
                this.saving = true;

                //Reset the errors
                this.errors = {};

                //Setters
                if (this.incident_type.cf_set_id !== null || this.incident_type.cf_set_id === 0)
                {
                    this.incident_type.sections = this.sections;
                }

                //Send it
                this.$http
                .post('admin/incident-types-edit' + (this.IncidentTypeId ? '/' + this.IncidentTypeId : ''), this.incident_type)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Incident Type Saved');

                    //Return to main list
                    if(!this.IncidentTypeId)
                    {
                        this.$router.push('/incidents/settings/incident-types/builder/'+response.data.IncidentTypeId);
                    }
                    else
                    {
                        this.$router.push('/incidents/settings#incident_types');
                    }
                })
                .catch(error => {
                    //Check for error
                    if(error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        //Alert the user
                        this.$toastr.error(error.response.data, 'Failed to Save Incident Type');
                    }
                })
                .then(response => {
                    //SHow loading
                    this.saving = false;
                });
            },

            getSectionName(base_section){
                //Send it
                return this.baseSections[base_section];
            },

            setFieldOrder(fieldId, event){
                //SEtup
                var newOrder = parseInt(event.target.value);

                //Get the fields parent_field_id
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Check the value?
                    if(newOrder < 0 || newOrder >= this.sections[i].fields.length)
                    {
                        //Stop here
                        this.$toastr.error('Invalid Order#, the order must be between 0 and ' + this.sections[i].fields.length);

                        //Return
                        return;
                    }

                    //Build a list of available order#
                    var orderNumbers = [];

                    //Loop and build
                    for(var t = 0; t < this.sections[i].fields.length; t++)
                    {
                        //Exclude the newOrder
                        if(t != newOrder)
                        {
                            orderNumbers.push(t);
                        }
                    }

                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(fieldId == this.sections[i].fields[j].id)
                        {
                            //Set the Order
                            this.sections[i].fields[j].order = newOrder;
                        }
                        else
                        {
                            //Pop the first value off the available order numbers
                            this.sections[i].fields[j].order = orderNumbers[0];

                            //Remove the order number
                            orderNumbers.splice(0, 1);
                        }
                    }

                    //Reorder ALL section fields
                    this.sections[i].fields.sort((a, b) => (a.order > b.order) ? 1 : -1);
                }
            },

            conditionalFieldOptions(fieldId){
                //Clone it
                var options = JSON.parse(JSON.stringify(this.conditionalFieldOptions_OLD));

                //Unset the ID from the Conditional Fields
                for(var i = 0; i < options.length; i++)
                {
                    //Check the ID
                    if(fieldId == options[i].value)
                    {
                        //Remove the Option
                        options.splice(i, 1);
                    }
                }

                //Send ti
                return options;
            },

            conditionalFieldValues(parentFieldId){
                //Setup
                var options = [];

                //Get the fields parent_field_id
                for(var i = 0; i < this.sections.length; i++)
                {
                    //Loop through the sections
                    for(var j = 0; j < this.sections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(parentFieldId == this.sections[i].fields[j].id)
                        {
                            //Add All the Options
                            options = this.sections[i].fields[j].options;
                        }
                    }
                }

                //Send it
                return options;
            },

            createdAfterPublished(item){
                //Check if the ID exists in the list
                if(this.publishedSections.length == 0)
                {
                    return true;
                }

                //Check for heading and paragraph types
                if(item.type && (item.type == 'Paragraph' || item.type == 'Heading'))
                {
                    //Stop here
                    return true;
                }

                //Check ALL
                for(var i = 0; i < this.publishedSections.length; i++)
                {
                    //Check each section
                    if(item.id == this.publishedSections.id)
                    {
                        return false;
                    }

                    //Check all the fields
                    for(var j = 0; j < this.publishedSections[i].fields.length; j++)
                    {
                        //Check the ID
                        if(item.id == this.publishedSections[i].fields[j].id)
                        {
                            //Match Found
                            return false;
                        }
                    }
                }

                //Return true - this was created after publish
                return true;
            }
        },

        mounted() {
            //Get the Incident TYpe
            this.getIncidentType();
        }
    }
</script>